export { View } from 'native-base';
